<template>
  <div class="data-list">
    <div class="list-item" v-for="(i, index) in jobList" :key="index" @click="handleJobInfo(i)">
      <div class="list-item-img">
        <!-- i.log || job_logo -->
        <img class="job-img" :src="brandMap[i.hotelName] || job_logo" alt="" />
      </div>
      <div class="list-item-left">
        <div class="job-title">{{ i.jobAdName || '-'}}</div>
        <div class="job-text">
          <span class="job-address"> {{ i.locText }} {{ i.hotelNameText ? `，${i.hotelNameText}`: '' }} 
          </span>
          <div class="job-date-wap">
            <span class="right-line job-date-wap-box" v-if="i.innerChannelClassificationTwoText">
              <span class="job-date-wap-text">
                {{ i.innerChannelClassificationTwoText || '-' }}
              </span>
            </span>
            <div class="job-date" v-if="i.postDate">
              <img class="job-date-img" :src="clock" alt="" />
              <span class="date"> {{ i.postDate || '-' }} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="list-item-right">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 4.5L16.5 12L9 19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" />
        </svg>
      </div>
    </div>
    <slot></slot>

    <Popup :show="showJobInfo" closeable :position="device === 'mb' ? 'bottom' : 'center'" @clickOverlay="closeModel"
      @click-close-icon="closeModel" class="job-info-popup">
      <jobInfo v-if="showJobInfo && jobDetail.jobAdId" :jobDetail="jobDetail"></jobInfo>
    </Popup>
  </div>
</template>

<script setup>
import job_logo from "@/assets/image/logo.png";
import clock from "@/assets/image/searchJob/clock.png";
import { ref, inject, defineProps, defineEmits } from "vue";
import { Popup } from "vant";
import brandMap from './brandMap.js'
const device = inject("device");
import jobInfo from "./jobInfo.vue";


const props = defineProps({
  jobList: {
    type: Array,
    default: () => [],
  },
  jobDetail: {
    type: Object,
    default: {}
  }
});
const emit = defineEmits(['getJobDetail','clearDetail'])

const showJobInfo = ref(false);

const handleJobInfo = (data) => {
  if (data.jobAdId){
    showJobInfo.value = true;
    emit('getJobDetail', data.jobAdId)
  }
};
const closeModel = () =>{
  showJobInfo.value = false
  emit('clearDetail')
}
</script>

<style lang="scss" scoped>
.data-list {
  margin-top: 32px;
  padding-bottom: 28px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;

  .list-item {
    padding: 40px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.3s ease;

    &:first-child {
      border-top: none;
    }

    &:hover {
      background-color: #FBF9F9;

      .list-item-right {
        svg {
          color: #C028B9;
        }
      }
    }
    
    &-img {
      display: flex;
      align-items: center;
    }

    &-left {
      flex: 1;
      width: 0;
    }

    .job-img {
      margin-right: 24px;
      display: block;
      width: 70px;
      height: 70px;
    }

    .job-title {
      font-weight: 500;
      font-size: 1.25rem;
      color: #000;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .job-text {
      margin-top: 16px;
      font-size: 0.85rem;
      color: #4d5660;
      display: flex;
      .job-address{
        flex-shrink: 0;
        white-space: nowrap;
          // 添加最大宽度和省略号显示
            max-width: 280px;
            overflow: hidden;
            text-overflow: ellipsis;
      }
      .job-address::after {
        display: inline-block;
        content: "";
        width: 1px;
        height: 12px;
        margin: 0 16px;
        background-color: rgba(0, 0, 0, 0.4);
      }

      .right-line {
        display: flex;
        align-items: center;
      }

      .right-line::after {
        display: inline-block;
        content: "";
        width: 1px;
        height: 12px;
        margin: 0 16px;
        background-color: rgba(0, 0, 0, 0.4);
      }

      .job-date-wap {
        display: flex;
          align-items: center;
          flex: 1;
          min-width: 0;
        .job-date-wap-text{
          // 基础样式
            white-space: normal;
            word-wrap: break-word;
            word-break: break-word;
            line-height: 1.4;
              // PC端：限制宽度，超出显示省略号
                @media (min-width: 768px) {
                  max-width: 200px;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                }
        }
      }

      .job-date {
        display: flex;
        align-items: center;

        .date {
          margin-left: 6px;
          white-space: nowrap;
        }
      }
    }
  }

  .list-item-right {
    display: flex;
    align-items: center;
    justify-content: end;
    width: 158px;
    cursor: pointer;

    svg {
      color: #002F61;
    }
  }
}

.job-info-popup {
  height: 90vh;
  max-width: 1250px;
}

::v-deep(.van-popup__close-icon) {
  --van-popup-close-icon-margin: 32px;
  --van-popup-close-icon-color: #002F61;
  --van-popup-close-icon-size: 2rem;
  transition: transform 0.3s ease-in-out;

  &:hover {
      transform: rotate(90deg);
      color: #000;
  }
}

@media (max-width: 767px) {
  .data-list {
    padding: 20px;
    margin: 0;

    .list-item {
      border-radius: 2px;
      padding: 16px;
      margin-bottom: 8px;
      border: none;

      .job-img {
        margin-right: 8px;
        width: 50px;
        height: 50px;
      }

      .job-text {
        flex-direction: column;
        margin-top: 6px;

        .job-address::after {
          display: none;
        }

        .job-date-wap {
          margin-top: 6px;
        }

        .right-line::after {
          margin: 0 12px;
        }
      }

      .job-date-wap-box {
        min-width: 0;
        overflow: hidden;
      }
      .job-date-wap-box.right-line{
        display: none;
      }

      .job-date-wap-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-shrink: 1;
      }
    }

    .list-item-right {
      width: 30px;
    }

    .job-date-img {
      width: 13px;
      height: 13px;
    }
  }

  ::v-deep(.van-popup__close-icon) {
    --van-popup-close-icon-margin: 24px;
    --van-popup-close-icon-size: 20px;
  }
}

@media (min-width: 767px) {
  .job-date-img {
    width: 16px;
    height: 16px;
  }
}
</style>
